import { useEffect, useState } from "react";

const fetchAsDataUrl = async (url: string): Promise<string | undefined> => {
  try {
    const res = await fetch(url);
    const blob = await res.blob();
    return await new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch {
    return undefined;
  }
};

/**
 * Resolves `data.providerGroupLogo` (an S3 URL) into an inline base64 data URL
 * so html2canvas can rasterize it during PDF generation. Returns `null` while
 * resolving; callers should defer triggering PDF generation until non-null.
 */
export const useResolveEncounterLogo = (data: any) => {
  const [resolved, setResolved] = useState<any>(null);

  useEffect(() => {
    if (!data) {
      setResolved(null);
      return;
    }
    const logoUrl = data.providerGroupLogo;
    if (!logoUrl || logoUrl.startsWith("data:")) {
      setResolved(data);
      return;
    }
    let cancelled = false;
    fetchAsDataUrl(logoUrl).then((dataUrl) => {
      if (cancelled) return;
      setResolved({ ...data, providerGroupLogo: dataUrl });
    });
    return () => {
      cancelled = true;
    };
  }, [data]);

  return resolved;
};
